import React, { Component } from "react";
import { connect } from "react-redux";
import Dialog from "material-ui/Dialog";
import { Field, reduxForm } from 'redux-form';

import SmallLoader from '../../../../../../../img/small-loader.gif';
import { checkFieldExistence, clearFieldErrorArray } from '../../../../../../AppConfig/actions';
import { renderAutoCompleteSingleSelect } from '../../../../../../../components/reduxFields';
import { CancelButton, SubmitButtonModal, SubmitButtonModalDisabled } from '../../../../../../../components/buttons';
import { MODULE } from './constants/ApiConstants';
import validate from './validate';
import { saveSkillAcquisitionProgramFromLibrary, getMasterCurriculumLibraries,getMasterDomainsByLibray, getMasterLibrayByDomain } from './actions/skillAquisitionProgramActions';

class ProgramFromLibraryModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
          open: true,
          domainId: props.domainId,
          parentDomainId: props.parentDomainId,
          programId: props.programId,
          patientId: props.patientId,
          filteredMasterPrograms: []
        };
    }

    componentWillMount() {
       this.props.getMasterCurriculumLibraries()
    }
    

    handleOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        if (this.state.open) {
          this.props.clearFieldErrorArray();
          this.setState({ open: false });
          this.props.closeDialog();
        }
    };

    componentWillReceiveProps(nextProps) {
        let self = this;
        document.onkeydown = function(evt) {
          evt = evt || window.event;
          if (evt.keyCode === 27) {
            self.handleClose();
          }
        };

        let filteredMasterPrograms = this.props.masterPrograms.filter(obj => {
          return (obj.domainId === this.props.domainId || obj.domainId === this.props.parentDomainId)
        })

        this.setState({
          filteredMasterPrograms : filteredMasterPrograms
        });
    }

    renderLoading() {
        return (
          <div>
            {this.props.loading ? (
              <div className="full_loader top0">
                <div className="small-loader">
                  <img src={SmallLoader} alt="" />
                </div>
              </div>
            ) : null}
          </div>
        );
    }

    onSubmitHandler(formProps) {
        if ((this.props.fieldError && this.props.fieldError.length) || (this.props.fieldErrorLoading)) { // Avoid Submit if field error checking
          return null;
        }
        let postData = {
          "skillsAcquisitionDomainId": this.state.domainId,
          "programIds": formProps.programId,
          "patientId": this.state.patientId,
        }
        this.props.clearFieldErrorArray();
        this.props.saveSkillAcquisitionProgramFromLibrary(postData, this.state.patientId, this.state.domainId);
        this.setState({ open: false });
        this.props.closeDialog();
        // this.props.loadData();
    }

    checkFieldDataExistence = (input, value, labelName) => {
        if (value.length > 0) {
          let postData = {
            'labelName': labelName,
            'tableName': `${MODULE}_${input.target.name}`.toUpperCase(),
            'value': value,
            'colmnName': input.target.name.toUpperCase(),
            'id': this.state.programId || 0,
            'patientId': this.state.patientId ? parseInt(this.state.patientId) : 0,
          };
          this.props.checkFieldExistence(postData);
        }
    };

    handleNewRequestLibrary = (input, selectedRecord) => {
      input.onChange(selectedRecord.value);
      this.props.getMasterDomainsByLibray(selectedRecord.value);
    };

    handleNewRequestDomain = (input, selectedRecord) => {
      input.onChange(selectedRecord.value);
      this.props.getMasterLibrayByDomain(selectedRecord.value);
    };

    handleNewRequestProgram = (input, selectedRecord) => {
      input.onChange(selectedRecord.value);
    };
    

    render() {
       let masterLibraries = this.props.masterCurriculumLibraries !== null && this.props.masterCurriculumLibraries;
       let masterDomains = this.props.masterDomainByLibrary !== null && this.props.masterDomainByLibrary;
       let masterPrograms = this.props.masterProgramByDomain !== null && this.props.masterProgramByDomain;
        const { handleSubmit } = this.props;
        let submitButton = this.props.loading ?
        <SubmitButtonModalDisabled label="Loading" /> :
        <SubmitButtonModal label="Save" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} />;
        const actions = [
            <CancelButton className="mr-15" onTouchTap={this.handleClose} />,
            submitButton,
          ];
        return (
            <Dialog
            className="custom_modal"
            title={
              this.state.programId
                ? "Edit Program"
                : "Add Program"
            }
            modal={false}
            open={this.state.open}
            actions={actions}
            autoScrollBodyContent={true}
          >
            {this.renderLoading()}
            <div className="row">
              <div className="col-sm-12">
                <form
                  className="readmin-form custom_form"
                  onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}
                >
                  <div className="row">
                    <div className="col-sm-12 require mt-25">
                      <Field
                        autoFocus={true}
                        name="libraryId"  
                        label="Library Name"      
                        handleNewRequest={this.handleNewRequestLibrary}
                        options={masterLibraries.data}
                        component={renderAutoCompleteSingleSelect}
                      />
                    </div>
                    <div className="col-sm-12 require mt-25">
                      <Field
                        autoFocus={true}
                        name="domainId"  
                        label="Domain Name"      
                        handleNewRequest={this.handleNewRequestDomain}
                        options={masterDomains.data}
                        component={renderAutoCompleteSingleSelect}
                      />
                    </div>
                    <div className="col-sm-12 require mt-25">
                      <Field
                        autoFocus={true}
                        name="programId"  
                        label="Program Name"      
                        handleNewRequest={this.handleNewRequestProgram}
                        options={masterPrograms.data}
                        component={renderAutoCompleteSingleSelect}
                      />
                    </div>
                  </div>
                  {/* <div className="row">
                    <div className="col-sm-3">
                      <Field
                        className="mt20 mb0"
                        name="isActive"
                        label="Is Active"
                        component={renderCheckBox}
                      />
                    </div>
                  </div> */}
                </form>
              </div>
            </div>
          </Dialog>
        )
    }
}

ProgramFromLibraryModal = reduxForm({
    form: 'ProgramFromLibraryModalForm',
    validate,
    enableReinitialize: true,
})(ProgramFromLibraryModal);

function mapStateToProps(state, props) {

    // let initialValueData = {
    //     isActive: true,
    // };

    return {
        loading: state.program.loading || state.skillAcquisitionProgram.loading,
        fieldError: state.appConfig.fieldError,
        fieldErrorLoading: state.appConfig.fieldErrorLoading,
        masterCurriculumLibraries: state.skillAcquisitionProgram.masterCurriculumLibraries,
        masterDomainByLibrary: state.skillAcquisitionProgram.masterDomainByLibrary,
        masterProgramByDomain: state.skillAcquisitionProgram.masterProgramByDomain
        //initialValues: initialValueData,
      }
}


export default connect(mapStateToProps, { checkFieldExistence, clearFieldErrorArray, saveSkillAcquisitionProgramFromLibrary, getMasterCurriculumLibraries, getMasterDomainsByLibray, getMasterLibrayByDomain}) (ProgramFromLibraryModal)



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/SkillAquisition/components/Program/programFromLibrary_Modal.js